export class InputDataTypeMaxMin {
    constructor(
        inputDataTypeMaxMinId: number,
        dataTypeIntMax: number,
        dataTypeIntMin: number,
        dataTypeDecimalMax: number,
        dataTypeDecimalMin: number,
        dataTypeDurationMax: Date,
        dataTypeDurationMaxDescription: string,
        dataTypeDurationMin: Date,
        dataTypeDurationMinDescription: string
    ) {
        this.inputDataTypeMaxMinId = inputDataTypeMaxMinId;
        this.dataTypeIntMax = dataTypeIntMax;
        this.dataTypeIntMin = dataTypeIntMin;
        this.dataTypeDecimalMax = dataTypeDecimalMax;
        this.dataTypeDecimalMin = dataTypeDecimalMin;
        this.dataTypeDurationMax = dataTypeDurationMax;
        this.dataTypeDurationMaxDescription = dataTypeDurationMaxDescription;
        this.dataTypeDurationMin = dataTypeDurationMin;
        this.dataTypeDurationMinDescription = dataTypeDurationMinDescription;
    }
    inputDataTypeMaxMinId: number;
    dataTypeIntMax: number;
    dataTypeIntMin: number;
    dataTypeDecimalMax: number;
    dataTypeDecimalMin: number;
    dataTypeDurationMax: Date;
    dataTypeDurationMaxDescription: string;
    dataTypeDurationMin: Date;
    dataTypeDurationMinDescription: string;
}
